"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazyContextProxy = void 0;
/*
  This utility is created to lazily load data and store it in context in particular format
  to use it you need to pass context in specific format
  {
    payersReq,
    payers
  }
  and consume 'data' property where needed
  dataReq is provided to consume other properties, e.g. 'loading' or 'run' for refresh
  The data will be loaded only when consuming component is mounted, and thus shared for all the application components
**/

var lazyContextProxy = function lazyContextProxy(context) {
  return new Proxy(context, {
    get: function get(target, name) {
      if (!(name in target)) {
        return undefined;
      }
      var targetData = target[name];
      if (name.includes('Req')) {
        return targetData;
      }
      var reqName = "".concat(name, "Req");
      if (target[reqName] && (target[reqName].data || target[reqName].loading)) {
        return target[reqName].data;
      }
      target[reqName].run();
    }
  });
};
exports.lazyContextProxy = lazyContextProxy;